import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../services/api';

const SuggestionsContext = createContext({
  suppliers: [],
  customers: [],
  items: [],
  device_types: [],
  model_names: [],
  capacities: [],
  colors: [],
  categories: [],
  cash_notes: [],
  cash_sources: [],
  notes: [],
  staff_notes: [],
  customer_notes: [],
  refresh: () => {},
});

export function SuggestionsProvider({ children }) {
  const [data, setData] = useState({
    suppliers: [], customers: [], items: [], device_types: [],
    model_names: [], capacities: [], colors: [], categories: [],
    cash_notes: [], cash_sources: [], notes: [],
    staff_notes: [], customer_notes: [],
  });

  const refresh = useCallback(async () => {
    try {
      const res = await api.get('/suggestions/all');
      const d = res.data || {};
      setData({
        suppliers: d.suppliers || [],
        customers: d.customers || [],
        items: d.items || [],
        device_types: d.device_types || [],
        model_names: d.model_names || [],
        capacities: d.capacities || [],
        colors: d.colors || [],
        categories: d.categories || [],
        cash_notes: d.cash_notes || [],
        cash_sources: d.cash_sources || [],
        notes: d.notes || [],
        staff_notes: d.staff_notes || [],
        customer_notes: d.customer_notes || [],
      });
    } catch {
      // ignore — keep previous data
    }
  }, []);

  useEffect(() => {
    // Only fetch if logged in (token present)
    if (localStorage.getItem('token')) {
      refresh();
    }
  }, [refresh]);

  return (
    <SuggestionsContext.Provider value={{ ...data, refresh }}>
      {children}
    </SuggestionsContext.Provider>
  );
}

export function useSuggestions() {
  return useContext(SuggestionsContext);
}
